import React from "react";

import { Grid, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Select } from "../../../../../../../../components/Form";
import SkeletonComponent from "../../../../../../../../components/Generic/Skeleton";
import { capitalizeFirstLetterAllWorlds } from "../../../../../../../../util/capitalizeFirstLetter";
import { DespatchesDetailsFields } from "../../../../../../../../util/enums";
import { useDespatchContext } from "../../../../context/DespatchContext";
import { DespatchSectionTitle } from "../../../components/SectionTitle";
import useAction from "../../../hooks/useAction";
import { DespatchSectionsProps } from "../../../types";

interface StatusSectionProps extends DespatchSectionsProps {}

export const DespatchStatusSection = ({ generateBaseFieldProps }: StatusSectionProps) => {
  const { t: translate } = useTranslation();
  const { despatch, handleUpdateDespatch } = useDespatchContext();
  const { getStatuses } = useAction();

  const { data: statuses, isFetching: isFetchingStatuses } = getStatuses();

  return (
    <Grid container spacing={2}>
      <DespatchSectionTitle>{translate("status")}</DespatchSectionTitle>
      <SkeletonComponent isLoading={isFetchingStatuses}>
        <Grid item xs={12} sm={6} md={3} lg={3}>
          <Select
            {...generateBaseFieldProps(DespatchesDetailsFields.STATUS)}
            displayEmpty
            value={despatch?.status || ""}
            onChange={({ target }) =>
              handleUpdateDespatch?.(DespatchesDetailsFields.STATUS, target.value)
            }
          >
            <MenuItem value="">
              {capitalizeFirstLetterAllWorlds(translate("selectStatus"), " ")}...
            </MenuItem>
            {statuses?.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {translate(option.label)}
              </MenuItem>
            ))}
          </Select>
        </Grid>
      </SkeletonComponent>
    </Grid>
  );
};
